// Analytics & marketing tag loader for A Girl's Girl.
// All providers are OPTIONAL and activate only when their env var is set,
// so the site is launch-ready without hardcoding any tracking IDs.
//
// Supported env vars (add to frontend/.env, then rebuild):
//   REACT_APP_GTM_ID                e.g. GTM-XXXXXXX  (Google Tag Manager)
//   REACT_APP_GA4_MEASUREMENT_ID    e.g. G-XXXXXXXXXX (Google Analytics 4)
//   REACT_APP_META_PIXEL_ID         e.g. 1234567890   (Meta / Facebook Pixel)
//   REACT_APP_LINKEDIN_PARTNER_ID   e.g. 1234567      (LinkedIn Insight Tag)

const injectScript = (src, attrs = {}) => {
  const s = document.createElement("script");
  s.async = true;
  s.src = src;
  Object.entries(attrs).forEach(([k, v]) => s.setAttribute(k, v));
  document.head.appendChild(s);
  return s;
};

const inlineScript = (code) => {
  const s = document.createElement("script");
  s.text = code;
  document.head.appendChild(s);
};

export function initAnalytics() {
  if (typeof window === "undefined") return;

  const GTM_ID = process.env.REACT_APP_GTM_ID;
  const GA4_ID = process.env.REACT_APP_GA4_MEASUREMENT_ID;
  const PIXEL_ID = process.env.REACT_APP_META_PIXEL_ID;
  const LINKEDIN_ID = process.env.REACT_APP_LINKEDIN_PARTNER_ID;

  // Google Tag Manager
  if (GTM_ID) {
    inlineScript(
      `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);})(window,document,'script','dataLayer','${GTM_ID}');`
    );
  }

  // Google Analytics 4 (direct, if not using GTM)
  if (GA4_ID) {
    injectScript(`https://www.googletagmanager.com/gtag/js?id=${GA4_ID}`);
    window.dataLayer = window.dataLayer || [];
    function gtag() {
      window.dataLayer.push(arguments);
    }
    window.gtag = gtag;
    gtag("js", new Date());
    gtag("config", GA4_ID, { send_page_view: true });
  }

  // Meta (Facebook/Instagram) Pixel
  if (PIXEL_ID) {
    inlineScript(
      `!function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];t=b.createElement(e);t.async=!0;t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}(window,document,'script','https://connect.facebook.net/en_US/fbevents.js');fbq('init','${PIXEL_ID}');fbq('track','PageView');`
    );
  }

  // LinkedIn Insight Tag
  if (LINKEDIN_ID) {
    window._linkedin_partner_id = LINKEDIN_ID;
    window._linkedin_data_partner_ids = window._linkedin_data_partner_ids || [];
    window._linkedin_data_partner_ids.push(LINKEDIN_ID);
    inlineScript(
      `(function(l){if(!l){window.lintrk=function(a,b){window.lintrk.q.push([a,b])};window.lintrk.q=[]}var s=document.getElementsByTagName("script")[0];var b=document.createElement("script");b.type="text/javascript";b.async=true;b.src="https://snap.licdn.com/li.lms-analytics/insight.min.js";s.parentNode.insertBefore(b,s);})(window.lintrk);`
    );
  }
}

// Fire a virtual pageview on client-side route changes (GA4 / GTM / Pixel).
export function trackPageView(path) {
  if (typeof window === "undefined") return;
  if (window.gtag && process.env.REACT_APP_GA4_MEASUREMENT_ID) {
    window.gtag("event", "page_view", { page_path: path });
  }
  if (window.dataLayer) {
    window.dataLayer.push({ event: "pageview", page_path: path });
  }
  if (window.fbq) {
    window.fbq("track", "PageView");
  }
}
